<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="个人数字空间页面" />
      <button
        class="hotspot back-arrow"
        type="button"
        aria-label="返回上一页"
        @click="goBack"
      />
      <button
        class="hotspot top-right-home"
        type="button"
        aria-label="右上角操作区回到主页"
        @click="goHome"
      />
      <button
        class="hotspot idcard-entry"
        type="button"
        aria-label="点击身份证卡片进入IdCard页面"
        @click="goIdCard"
      />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-flow-space-no-status.png";

export default {
  name: "AlipayFlowSpace",
  data() {
    return {
      screenImage,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push("/alipay-flow");
    },
    goIdCard() {
      this.$router.push({ name: "AlipayIdImageUpdate" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}

.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  overflow: visible;
  border-radius: 0;
}

.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}

.idcard-entry {
  left: 8%;
  top: 57.5%;
  width: 84%;
  height: 12.5%;
}

.back-arrow {
  left: 1.5%;
  top: 1.8%;
  width: 9%;
  height: 6%;
}

.top-right-home {
  right: 2%;
  top: 1.6%;
  width: 29%;
  height: 6.2%;
}
</style>
